/* eslint-disable react/display-name */
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { MainVideoView } from './mainVideoView';
import { withScreenSize } from '../common/utilities/withScreenSize.jsx';
import { smallMediaQuery, largeMediaQuery } from '../../common/utilities/sizeHelpers';
import { DisplayAdWidget } from '../ads/displayAdWidget.jsx';
import { MoreFeaturedVideos } from './moreFeaturedVideos';
import { DataFetchSpinner } from '../common/dataFetchSpinner/dataFetchSpinner';
import { translate } from  '../../common/translation/translate';
import { DisplayAdUnit } from '../../containers/ads/displayAdUnitContainer';

let muteByDefault = false;

export const FeaturedVideosPageView = withScreenSize(memo(({
    currentVideoPlaylist,
    trustedPrerollUrl,
    currentVideo,
    pageId,
    platformCode,
    setCurrentVideoInfo,
    onNewVideoStarted,
    onVideoPaused,
    onVideoStopped,
    onVideoCompleted,
    onVideoViewed,
    videoPrerollAdClient,
    featuredVideoPrerollPlacementId,
    currentVideoDescription,
    currentVideoPublishDate,
    videosIsFetching,
    selectVideo,
    isDesktop,
    isTablet,
    isMobile
}) => {
    return (
        <Container>
            <Window>
                <Header>
                    {translate('featuredVideos')}
                </Header>
                <TopContainer>
                    <MainVideoView
                        currentVideoPlaylist={currentVideoPlaylist}
                        trustedPrerollUrl={trustedPrerollUrl}
                        currentVideo={currentVideo}
                        pageId={pageId}
                        platformCode={platformCode}
                        setCurrentVideoInfo={setCurrentVideoInfo}
                        onNewVideoStarted={onNewVideoStarted}
                        onVideoPaused={onVideoPaused}
                        onVideoStopped={onVideoStopped}
                        onVideoCompleted={onVideoCompleted}
                        onVideoViewed={onVideoViewed}
                        muteByDefault={muteByDefault}
                        videoPrerollAdClient={videoPrerollAdClient}
                        featuredVideoPrerollPlacementId={featuredVideoPrerollPlacementId}
                        currentVideoDescription={currentVideoDescription}
                        currentVideoPublishDate={currentVideoPublishDate}
                    />
                    {isDesktop
                        && <AdContainer>
                            <DisplayAdUnit
                                width={300}
                                height={600}
                                slotId='videos_x16'
                            />
                        </AdContainer>
                    }
                </TopContainer>
                <AdContainer>
                    {isTablet
                        && <DisplayAdUnit
                            width={320}
                            height={50}
                            slotId='videos_x89'
                        />
                    }
                    {isMobile
                        && <DisplayAdUnit
                            width={300}
                            height={250}
                            slotId='videos_x13'
                        />
                    }
                </AdContainer>
                {videosIsFetching
                    && <SpinnerContainer>
                        <DataFetchSpinner width={65} height={65} strokeWidth={6} />
                    </SpinnerContainer>
                }
                <MoreFeaturedVideos
                    selectVideo={selectVideo}
                />
            </Window>
        </Container>
    );
}));

FeaturedVideosPageView.displayName = 'FeaturedVideosPageView';
FeaturedVideosPageView.propTypes = {
    currentVideoPlaylist: PropTypes.array,
    trustedPrerollUrl: PropTypes.string,
    currentVideo: PropTypes.object,
    pageId: PropTypes.string,
    platformCode: PropTypes.string,
    setCurrentVideoInfo: PropTypes.any,
    onNewVideoStarted: PropTypes.any,
    onVideoPaused: PropTypes.any,
    onVideoStopped: PropTypes.any,
    onVideoCompleted: PropTypes.any,
    onVideoViewed: PropTypes.any,
    currentVideoDescription: PropTypes.string,
    currentVideoPublishDate: PropTypes.number,
    videosIsFetching: PropTypes.any,
    selectVideo: PropTypes.any,
    isDesktop: PropTypes.any,
    isTablet: PropTypes.any,
    isMobile: PropTypes.any
};

const Container = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
`;

const Window = styled.div`
    width: 1232px;
`;

const TopContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;

    @media ${smallMediaQuery} {
        justify-content: start;
    }
`;

const Header = styled.h2`
    font-size: 24px;
    color: #fff;
    font-weight: 600;
    margin-left: 10%;

    @media ${largeMediaQuery} {
        margin-left: 0;
    }
`;

const AdContainer = styled.li`
    @media ${largeMediaQuery} {
        padding: 0 0 0 8px;
    }
`;

const SpinnerContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 73px;
`;
